import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class Cocktail extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, isDanse, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);
		this.isDanse = isDanse;

		if (data) {
			this.data = {entreTable: parseFloat(data.et), isEcranMural: (data.em == "true")};
		}
		else {
			this.data = {entreTable: 2.5, isEcranMural: false};
		}

		this.buffetObject = this.currentEnv.getObjectByName("Buffet_" + this.roomName);
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);

		this.roomWithDifferentPlacement = ["8", "9", "10", "11"];
	}

	Show() {
		if (!this.refCocktail) {
			this.CreateCocktail();
		}
		else if (!this.refBuffet) {
			this.CreateBuffet();
		}
		else if (!this.refBuffetPetit) {
			this.CreateBuffetPetit();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var currentCocktail = [];
			var currentBuffet = [];
			var currentBuffetPetit = [];
			var currentPlafonnier = [];
			var currentSortieSecours = [];
			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Mange_Debout") {
					currentCocktail.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = !this.isDanse;
					this.whereToAddObjects.children[i].simsData.id = currentCocktail.length;
				}
				if (this.whereToAddObjects.children[i].name == "Table_Buffet") {
					currentBuffet.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData.id = currentBuffet.length;
				}
				if (this.whereToAddObjects.children[i].name == "Table_Buffet_Petit") {
					currentBuffetPetit.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData.id = currentBuffetPetit.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}

			if (this.roomName != "Lully") {
				var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
				if (plafonnierPos) {
					if (currentPlafonnier.length >= 1) {
						this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
						if (this.data.isEcranMural) {
							currentPlafonnier[0].visible = true;
						}
					}
					else {
						this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
					}
				}
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			var buffetPos = this.buffetObject.getObjectByName("Buffet_" + this.roomConfig);
			var currentNbBuffet = 0;
			var currentNbBuffetPetit = 0;

			if (buffetPos) {
				if (buffetPos.children.length) {
					for (var i = 0; i < buffetPos.children.length; i++) {
						if (buffetPos.children[i].name.includes("Petit")) {
							if (currentNbBuffetPetit < currentBuffet.length) {
								this.objectGenerator.ApplyTransform(currentBuffetPetit[currentNbBuffetPetit], {refObject: buffetPos.children[i]});
								currentBuffetPetit[currentNbBuffetPetit].visible = true;
							}
							else {
								currentBuffetPetit.push(this.objectGenerator.CloneElement(this.refBuffetPetit, this.whereToAddObjects, {refObject: buffetPos.children[i]}));
								currentBuffetPetit[currentBuffetPetit.length - 1].simsData.id = currentBuffetPetit.length;
							}
							currentNbBuffetPetit++;
						}
						else {
							if (currentNbBuffet < currentBuffet.length) {
								this.objectGenerator.ApplyTransform(currentBuffet[currentNbBuffet], {refObject: buffetPos.children[i]});
								currentBuffet[currentNbBuffet].visible = true;
							}
							else {
								currentBuffet.push(this.objectGenerator.CloneElement(this.refBuffet, this.whereToAddObjects, {refObject: buffetPos.children[i]}));
								currentBuffet[currentBuffet.length - 1].simsData.id = currentBuffet.length;
							}
							currentNbBuffet++;
						}
					}
				}
				else {
					if (currentBuffet.length > 0) {
						this.objectGenerator.ApplyTransform(currentBuffet[0], {refObject: buffetPos});
						currentBuffet[0].visible = true;
					}
					else {
						currentBuffet.push(this.objectGenerator.CloneElement(this.refBuffet, this.whereToAddObjects, {refObject: buffetPos}));
						currentBuffet[currentBuffet.length - 1].simsData.id = currentBuffet.length;
					}
				}
			}

			if (!this.isDanse) {
				var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
				var zoneDelimData;
				if (delim) {				
					zoneDelimData = this.SetupDelimData(delim);
				}
				else {
					zoneDelimData = this.SetupDelimData(this.delimZones);
				}
				if (zoneDelimData.length) {
					zoneDelimData = zoneDelimData[0];
				}

				switch(this.roomConfig) {
					case "1":
						zoneDelimData.minZ += 3;
						zoneDelimData.maxZ -= 2;
						zoneDelimData.minX += 3.5;
						zoneDelimData.maxX -= 2;
						break;
					case "2":
						zoneDelimData.minZ += 4;
						zoneDelimData.maxZ -= 3;
						zoneDelimData.minX += 4;
						zoneDelimData.maxX -= 2;
						break;
					case "3":
						zoneDelimData.minZ += 4;
						zoneDelimData.maxZ -= 2;
						zoneDelimData.minX += 2;
						zoneDelimData.maxX -= 4;
						break;
					case "1_2":
						zoneDelimData.minZ += 3;
						zoneDelimData.maxZ -= 4;
						zoneDelimData.minX += 4;
						zoneDelimData.maxX -= 2;
						break;
					case "2_3":
						zoneDelimData.minZ += 4;
						zoneDelimData.maxZ -= 4;
						zoneDelimData.minX += 5;
						zoneDelimData.maxX -= 4;
						break;
					case "1_2_3":
						zoneDelimData.minZ += 4;
						zoneDelimData.maxZ -= 4;
						zoneDelimData.minX += 5;
						zoneDelimData.maxX -= 3;
						break;
					case "4":
					case "8":
						zoneDelimData.minZ += 2;
						zoneDelimData.maxZ -= 2;
						zoneDelimData.minX += 2;
						zoneDelimData.maxX -= 2;
						break;
					case "5":
					case "6":
						zoneDelimData.minZ += 2;
						zoneDelimData.maxZ -= 2;
						zoneDelimData.minX += 3;
						zoneDelimData.maxX -= 3;
						break;
					case "7":
						zoneDelimData.minZ += 2;
						zoneDelimData.maxZ -= 3;
						zoneDelimData.minX += 3;
						zoneDelimData.maxX -= 3;
						break;
					case "9":
					case "10":
						zoneDelimData.minZ += 3;
						zoneDelimData.maxZ -= 3;
						zoneDelimData.minX += 2;
						zoneDelimData.maxX -= 2;
						break;
					case "11":
						zoneDelimData.minZ += 3;
						zoneDelimData.maxZ -= 3;
						zoneDelimData.minX += 3;
						zoneDelimData.maxX -= 2;
						break;
					case "Lully":
						zoneDelimData.minZ += 4;
						zoneDelimData.maxZ -= 4;
						zoneDelimData.minX += 4;
						zoneDelimData.maxX -= 2;
						break;
				}

				var realDistance = {};
				var newPos = {};
				realDistance.x = Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / (Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / this.data.entreTable)) * 10) / 10;
				realDistance.z = Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / (Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / this.data.entreTable)) * 10) / 10;
				
				var newCocktail;
				var cocktailCount = 0;
				var nbRange = 0;
				var ratioSup;

				if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
					ratioSup = realDistance.x / 2;
					for (var i = zoneDelimData.minZ; i < zoneDelimData.maxZ; i += realDistance.z) {
						for (var j = (nbRange%2 == 0)?zoneDelimData.minX:zoneDelimData.minX + ratioSup; j < zoneDelimData.maxX; j += realDistance.x) {
							newPos.posZ = i;
							newPos.posX = j;

							if (cocktailCount < currentCocktail.length) {
								this.objectGenerator.ApplyTransform(currentCocktail[cocktailCount], newPos);
							}
							else {
								currentCocktail.push(this.objectGenerator.CloneElement(this.refCocktail, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
								currentCocktail[currentCocktail.length - 1].simsData.id = currentCocktail.length;
								/*newCocktail = this.refCocktail.clone();
								this.whereToAddObjects.add(newCocktail);
								newCocktail.rotation.set(0, 0, 0);
								this.objectGenerator.ApplyTransform(newCocktail, newPos);*/
							}

							cocktailCount++;
						}
						nbRange++;
					}
				}
				else {
					ratioSup = realDistance.z / 2;
					for (var i = zoneDelimData.minX; i < zoneDelimData.maxX; i += realDistance.x) {
						for (var j = (nbRange%2 == 0)?zoneDelimData.minZ:zoneDelimData.minZ + ratioSup; j < zoneDelimData.maxZ; j += realDistance.z) {
							newPos.posX = i;
							newPos.posZ = j;

							if (cocktailCount < currentCocktail.length) {
								this.objectGenerator.ApplyTransform(currentCocktail[cocktailCount], newPos);
							}
							else {
								currentCocktail.push(this.objectGenerator.CloneElement(this.refCocktail, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
								currentCocktail[currentCocktail.length - 1].simsData.id = currentCocktail.length;
								/*newCocktail = this.refCocktail.clone();
								this.whereToAddObjects.add(newCocktail);
								newCocktail.rotation.set(0, 0, 0);
								this.objectGenerator.ApplyTransform(newCocktail, newPos);*/
							}

							cocktailCount++;
						}
						nbRange++;
					}
				}

				if (currentCocktail.length > cocktailCount) {
					this.HideObjectAdded(currentCocktail, cocktailCount);
				}
				this.data.type = "Cocktail";
				this.data.cocktailCount = cocktailCount;
			}
			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
		}
	}

	Modify(value) {
		if (value.type == "entreTable") {
			this.data.entreTable = parseFloat(value.value);
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig, isDanse) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
		this.isDanse = isDanse;
	}

	CreateCocktail() {
		this.refCocktail = this.whereToAddObjects.getObjectByName("Mange_Debout");
		if(this.refCocktail) {
			this.refCocktail.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateCocktail();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Mange_Debout", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateBuffet() {
		this.refBuffet = this.whereToAddObjects.getObjectByName("Table_Buffet");
		if (this.refBuffet) {
			this.refBuffet.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateBuffet();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Table_Buffet", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateBuffetPetit(sendOneTime) {
		this.refBuffetPetit = this.whereToAddObjects.getObjectByName("Table_Buffet_Petit");
		if (this.refBuffetPetit) {
			this.refBuffetPetit.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateBuffetPetit();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Table_Buffet_Petit", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	ResetBaseConfig() {
		this.data = {entreTable: 2.5};
	}
}